import React, { useCallback, useState } from 'react';
import { path } from 'ramda';
import { useDispatch } from 'react-redux';
import { ManagedPopup } from 'js/components/common/Popup';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector } from 'js/store/hooks';
import { WebContentInner } from 'js/components/system/WebContent';
import { CheckboxShallow } from 'js/components/common/Fields/Checkbox';
import { LocalConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';
import { setSessionEnabledAction } from 'js/hooks/session/store/actions';
import { useOnClose } from 'js/components/common/PopupManager';
import style from './TimeIsFlyingPopup.scss';

const popupClassNames = {
    inner: style.popupInner
};

export const TimeIsFlyingPopup = ({ id }) => {
    const t = useTranslations('playtech.mobile.system.');
    const closeManaged = useOnClose(id);
    const title = t('timeIsFlying');
    const content = useAppSelector(path(['sessionTimerWebContent', 'timeIsFlying']));
    const [showConfirmDialog, setShowConfirmation] = useState(false);
    const [preventShowAgain, setPreventShowAgain] = useState(false);
    const onCloseManaged = useCallback(() => {
        if (preventShowAgain) {
            setShowConfirmation(true);
        } else {
            closeManaged();
        }
    }, [closeManaged, preventShowAgain]);
    const dispatch = useDispatch();
    const onAccept = () => {
        dispatch(setSessionEnabledAction(false));
    };

    const onShowAgainChange = (e) => {
        setPreventShowAgain(e.target.checked);
    };

    const buttons = [
        {
            text: t('continue'),
            onClick: onCloseManaged
        }
    ];

    return (
        <>
            {!showConfirmDialog && (
                <ManagedPopup title={title} buttons={buttons} classNames={popupClassNames} onClose={closeManaged}>
                    <WebContentInner content={content} />
                    <CheckboxShallow
                        name="preventShowAgain"
                        label={t('showAgain')}
                        aria-label={t(['showAgain', 'playtech.mobile.system.checkbox.aria-label'])}
                        onChange={onShowAgainChange}
                    />
                </ManagedPopup>
            )}
            {showConfirmDialog && (
                <LocalConfirmationPopup
                    onAccept={onAccept}
                    acceptBtnText="playtech.mobile.system.yes.button.title"
                    declineBtnText="playtech.mobile.system.no.button.title"
                    onClose={closeManaged}
                    title={t('title.warning')}
                    content={t('timeIsFlying.confirm')}
                />
            )}
        </>
    );
};
